import React from "react";

interface Props {
  color?: string;
}

export const CadeadoIcon = (props: Props) => (
  <svg
    width="84"
    height="83"
    viewBox="0 0 84 83"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M66.13 34.4698H69.577C70.4912 34.4698 71.3679 34.833 72.0144 35.4794C72.6608 36.1258 73.024 37.0026 73.024 37.9168V72.3865C73.024 73.3007 72.6608 74.1774 72.0144 74.8238C71.3679 75.4703 70.4912 75.8334 69.577 75.8334H14.4255C13.5113 75.8334 12.6345 75.4703 11.9881 74.8238C11.3417 74.1774 10.9785 73.3007 10.9785 72.3865V37.9168C10.9785 37.0026 11.3417 36.1258 11.9881 35.4794C12.6345 34.833 13.5113 34.4698 14.4255 34.4698H17.8725V31.0228C17.8725 27.8542 18.4966 24.7166 19.7091 21.7891C20.9217 18.8617 22.699 16.2018 24.9396 13.9612C27.1802 11.7206 29.8401 9.94332 32.7676 8.73074C35.695 7.51815 38.8326 6.89404 42.0012 6.89404C45.1699 6.89404 48.3075 7.51815 51.2349 8.73074C54.1624 9.94332 56.8223 11.7206 59.0629 13.9612C61.3034 16.2018 63.0808 18.8617 64.2933 21.7891C65.5059 24.7166 66.13 27.8542 66.13 31.0228V34.4698ZM17.8725 41.3637V68.9395H66.13V41.3637H17.8725ZM38.5543 48.2577H45.4482V62.0456H38.5543V48.2577ZM59.2361 34.4698V31.0228C59.2361 26.4519 57.4203 22.0681 54.1881 18.836C50.956 15.6038 46.5722 13.788 42.0012 13.788C37.4303 13.788 33.0465 15.6038 29.8144 18.836C26.5822 22.0681 24.7664 26.4519 24.7664 31.0228V34.4698H59.2361Z"
      fill={props.color ?? "#F43636"}
    />
  </svg>
);
